var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitation-accept"},[_c('h1',[_vm._v("Accept invitation")]),_vm._v(" "),(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('error-box',{attrs:{"error":_vm.error}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f213dc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/invitations/InvitationAccept.vue
// module id = null
// module chunks = 